import { useGlobalContext } from "../../../../../Context/Context";
import { useState } from "react";
import axios from "axios";
import imageImg from "../../../../../picture/slika.png";
import textImg from "../../../../../picture/text.png";
import wordImg from "../../../../../picture/word.png";
import pdfImg from "../../../../../picture/pdf.png";
import scanImg from "../../../../../picture/scan.png";
import editImg from "../../../../../picture/edit.png";
import downloadImg from "../../../../../picture/DownloadFile.png";
import visibleImg from "../../../../../picture/Visible.png";
import forwardImg from "../../../../../picture/forward.png";
import deleteImg from "../../../../../picture/delete.png";
import notificationImg from "../../../../../picture/notification.png";
import printImg from "../../../../../picture/print.png";
import reloadImg from "../../../../../picture/timer-language.png";
import arrowImg from "../../../../../picture/NextLanguage.png";
import ConfirmationModal from "../../../FolderDocument/ConfirmationModal";
import WarningModal from "../../WarningModal";

const styles = {
  cell: { padding: "5px", textAlign: "center" },
  smallCell: { width: "40px", textAlign: "center", cursor: "pointer" },
  icon: { width: "30px", height: "30px" },
  filledDiv: { width: "25px", height: "25px", margin: "auto" },
  arrowImg: {
    transform: "rotate(90deg)",
    transition: "transform 0.3s ease"
  },
  expandedArrow: {
    transform: "rotate(270deg)",
    transition: "transform 0.3s ease"
  }
};

function DokumentaKolektivnaOpremaArhivirana({ dokumenta, setDokumenta }) {
  const { dictionary, baseUrl, apiKey, loggedUser } = useGlobalContext();

  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedField, setSelectedField] = useState({
    documentId: "",
    documentType: ""
  });
  const [deleteData, setDeleteData] = useState({
    documentId: "",
    documentType: ""
  });
  const [isOpenWarningModal, setIsOpenWarningModal] = useState(false);

  const handleSelectDocument = (documentId, documentType) => {
    setSelectedField((prev) =>
      prev.documentId === documentId && prev.documentType === documentType
        ? { documentId: "", documentType: "" }
        : { documentId, documentType }
    );
  };

  const handleRestore = async (dokument) => {
    if (!window.confirm(`Vratiti u važeća: ${dokument.naziv}?`)) return;

    setDokumenta((prev) => prev.filter((d) => d.id !== dokument.id));

    const formData = new FormData();
    formData.append("document_id", dokument.id);
    formData.append("user_id", loggedUser.id);
    formData.append("api_key", apiKey);

    try {
      const { data } = await axios.post(
        `${baseUrl}/machines/restore_document.php`,
        formData
      );
      if (data.status === 200) {
        window.dispatchEvent(new Event("machineAdded"));
      } else {
        window.dispatchEvent(new Event("machineAdded"));
        alert("Greška na serveru");
      }
    } catch (error) {
      window.dispatchEvent(new Event("machineAdded"));
      console.error(error);
    }
  };

  const isDeleteOneVersion = deleteData.documentId && deleteData.documentType;
  const handleOpenDelete = (id) => {
    if (selectedField.documentId === id && selectedField.documentType) {
      const postojeciDokument = dokumenta.find((d) => d.id === id);
      if (postojeciDokument[selectedField.documentType] === "") {
        setIsOpenWarningModal(true);
        return;
      }
      setDeleteData(selectedField);
      return;
    }
    setDeleteData({ documentId: id, documentType: "" });
  };

  const handleConfirmDelete = () => {
    if (isDeleteOneVersion) {
      setDokumenta(
        dokumenta.map((d) =>
          d.id !== deleteData.documentId
            ? d
            : { ...d, [deleteData.documentType]: "" }
        )
      );
    } else {
      setDokumenta(dokumenta.filter((d) => d.id !== deleteData.documentId));
    }
    setDeleteData({ documentId: "", documentType: "" });
  };

  return (
    <>
      <table
        style={{
          width: "88%",
          float: "right",
          marginTop: "10px",
          marginBottom: "10px"
        }}
      >
        <thead>
          <tr>
            <th style={styles.smallCell}>
              <img src={textImg} style={{ width: "30px" }} />
            </th>
            <th style={styles.smallCell}>
              <img src={wordImg} style={{ width: "30px" }} />
            </th>
            <th style={styles.smallCell}>
              <img src={pdfImg} style={{ width: "30px" }} />
            </th>
            <th style={styles.smallCell}>
              <img src={imageImg} style={{ width: "30px" }} />
            </th>
            <th style={styles.smallCell}>
              <img src={scanImg} style={{ width: "30px" }} />
            </th>
            <th style={{ ...styles.cell, width: "50%" }}>
              {dictionary["arhiviranaDokumenta"]}
            </th>
            <th
              colSpan={"8"}
              style={{ textAlign: "right", paddingRight: "10px" }}
            >
              <img
                src={arrowImg}
                style={{
                  width: "10px",
                  cursor: "pointer",
                  ...(isExpanded ? styles.expandedArrow : styles.arrowImg)
                }}
                onClick={() => setIsExpanded(!isExpanded)}
                alt="toggle"
              />
            </th>
          </tr>
        </thead>
        {isExpanded && (
          <tbody>
            {dokumenta.map((dokument) => (
              <tr key={dokument.id}>
                {["text", "word", "pdf", "image", "scan"].map((type) => (
                  <td
                    key={type}
                    onClick={() => handleSelectDocument(dokument.id, type)}
                    style={{
                      ...styles.smallCell,
                      border:
                        selectedField.documentId === dokument.id &&
                        selectedField.documentType === type
                          ? "2px solid black"
                          : ""
                    }}
                  >
                    <div
                      style={{
                        ...styles.filledDiv,
                        backgroundColor: dokument[type]
                      }}
                    ></div>
                  </td>
                ))}
                <td style={styles.cell}>{dokument.naziv}</td>
                <td style={styles.smallCell}>
                  <img src={editImg} style={{ width: "30px" }} />
                </td>
                <td style={styles.smallCell}>
                  <img src={downloadImg} style={{ width: "25px" }} />
                </td>
                <td style={styles.smallCell}>
                  <img src={forwardImg} style={{ width: "30px" }} />
                </td>
                <td style={styles.smallCell}>
                  <img src={printImg} style={{ width: "20px" }} />
                </td>
                <td
                  style={styles.smallCell}
                  onClick={() => handleOpenDelete(dokument.id)}
                >
                  <img src={deleteImg} style={{ width: "25px" }} />
                </td>
                <td style={styles.smallCell}>
                  <img src={visibleImg} style={{ width: "30px" }} />
                </td>
                <td
                  onClick={() => handleRestore(dokument)}
                  style={styles.smallCell}
                >
                  <img
                    src={reloadImg}
                    style={{ width: "20px" }}
                    title="Vrati u važeća"
                  />
                </td>
                <td style={styles.smallCell}>
                  <img src={notificationImg} style={{ width: "30px" }} />
                </td>
              </tr>
            ))}
          </tbody>
        )}
      </table>

      {deleteData.documentId && (
        <ConfirmationModal
          handleConfirm={handleConfirmDelete}
          text={
            isDeleteOneVersion
              ? `Da li želite da obrišete ${deleteData.documentType} verziju?`
              : dictionary["confirmDeleteDocumentAllVersions"]
          }
          handleCancel={() =>
            setDeleteData({ documentId: "", documentType: "" })
          }
        />
      )}

      {isOpenWarningModal && (
        <WarningModal
          text={dictionary["nepostojecaVerzija"]}
          handleCancel={() => setIsOpenWarningModal(false)}
        />
      )}
    </>
  );
}

export default DokumentaKolektivnaOpremaArhivirana;
